module.exports = __webpack_public_path__ + "img/grafana.1c1f53c5.png";